import React, { useState, useEffect, useRef } from 'react';
/** lib **/
import { Link } from 'react-router-dom';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';
import { client } from 'api/microcms';
/** styles,images **/
import s from '../../styles/organisms/news.module.scss';
import { REGISTER_FORM_URL } from '../../const';
import dayjs from 'dayjs';

export const News: React.FC = () => {
  const [news, setNews] = useState([]);

  const inViewRef1 = useRef<HTMLHeadingElement>(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const animationEl = [inViewRef1];

  const clickBtn = () => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'click', {
        action: 'サポーター登録ボタンクリック(ファーストビュー)',
      });
    }
    window.open(REGISTER_FORM_URL, '_blank');
  };


  const tagImage = (tag: string): string => {
    console.log(tag)
    switch (tag) {
      case "お知らせ":
        return "friend01.png";
      case "グループ情報":
        return "friend02.png";
      case "物件情報":
        return "friend03.png";
      case "プレスリリース":
        return "friend04.png";
      case "メディア掲載":
        return "friend03.png";
      case "イベント":
        return "friend03.png";
      default:
        return "friend01.png";
    }
  }

  useEffect(() => {
    client
      .get({
        endpoint: "news",
      })
      .then((res) => {
        setNews(res.contents)
      })
      .catch((err) => console.log(err));
  }, []);


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(s.inview);
          } else {
            entry.target.classList.remove(s.inview);
          }
        });
      },
      {
        root: null,
        rootMargin: '-20% 0px -20% 0px',
        threshold: 0,
      },
    );
    animationEl.forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      animationEl.forEach((ref) => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, [animationEl]);

  return (
    <div className={s.newsWrapper}>

      <ul className={s.newsList}>
        {news.map((newsItem: any) => (
          <li key={newsItem.id}>
            {newsItem.link ?
              // 内部リンクがある場合
              <Link to={newsItem.link}>
                <div className={s.text}>
                  <div className={s.date}>
                    <p>{dayjs(newsItem.publishAt).format("YYYY/MM/DD")}</p>
                    <span className={s.tag}>
                      {newsItem.tag[0]}
                    </span>
                  </div>
                  <div className={s.title}>{newsItem.title}</div>
                </div>
              </Link>
              :
              newsItem.external_link ?
                // 外部リンクがある場合
                <a href={newsItem.external_link} target="_blank" rel="noreferrer">
                  <div className={s.text}>
                    <div className={s.date}>
                      <p>{dayjs(newsItem.publishAt).format("YYYY/MM/DD")}</p>
                      <span className={s.tag}>
                        {newsItem.tag[0]}
                      </span>
                    </div>

                    <div className={s.title}>{newsItem.title}</div>
                  </div>
                </a> : newsItem.contents ?
                  // ニュース本文がある場合
                  <Link to={`/news?id=${newsItem.id}`}>
                    <div className={s.text}>
                      <div className={s.date}>
                        <p>{dayjs(newsItem.publishAt).format("YYYY/MM/DD")}</p>
                        <span className={s.tag}>
                          {newsItem.tag[0]}
                        </span>
                      </div>
                      <div className={s.title}>{newsItem.title}</div>
                    </div>
                  </Link> :
                  // タイトルのみ
                  <div className={s.text}>
                    <div className={s.date}>
                      <p>{dayjs(newsItem.publishAt).format("YYYY/MM/DD")}</p>
                      <span className={s.tag}>
                        {newsItem.tag[0]}
                      </span>
                    </div>
                    <div className={s.title}>{newsItem.title}</div>
                  </div>}
          </li>
        ))}
      </ul>
    </div>
  );
};
